import { render } from "./PropertiesRank.vue?vue&type=template&id=6afaf528&scoped=true"
import script from "./PropertiesRank.vue?vue&type=script&lang=js"
export * from "./PropertiesRank.vue?vue&type=script&lang=js"

import "./PropertiesRank.vue?vue&type=style&index=0&id=6afaf528&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afaf528"]])

export default __exports__